module.exports = {
          srcSet: "/_next/static/images/icon-200-e7356acfcaf954651095791b727d3369.png"+" 200w",
          images:[ {path: "/_next/static/images/icon-200-e7356acfcaf954651095791b727d3369.png",width: 200,height: 200}],
          src: "/_next/static/images/icon-200-e7356acfcaf954651095791b727d3369.png",
          toString:function(){return "/_next/static/images/icon-200-e7356acfcaf954651095791b727d3369.png"},
          placeholder: undefined,
          width: 200,
          height: 200
      }